import React from "react";
import { getFieldEditor } from "./utils/FieldEditorRegistry";
import ConditionsEditor from "./partials/ConditionsEditor";
import "./css/field-editor.css";
import "./controls/controls.css";

export default function FieldEditor({ selectedField, onUpdateField, schema, activeTabId }) {
  if (!selectedField) {
    return (
      <div className="text-muted p-4 text-center">
        Aucun champ sélectionné
      </div>
    );
  }

  const EditorComponent = getFieldEditor(selectedField);

  if (!EditorComponent) {
    return (
      <div className="alert alert-warning">
        Aucun éditeur trouvé pour le type{" "}
        <strong>{selectedField.type}</strong>.
      </div>
    );
  }

  /* ===============================
   * ConditionsEditor → commit complet
   * =============================== */
  const handleConditionsSave = (updatedField) => {
    // on relaie tel quel vers le parent

    console.log(updatedField)

    onUpdateField(updatedField);
  };

  return (
    <div id="formbuilder-editor">
      <EditorComponent
        field={selectedField}
        onChange={(key, value) => {
          // cas : l’éditeur renvoie un champ complet
          if (typeof key === "object" && key !== null) {
            onUpdateField(key);
            return;
          }

          // cas classique key / value
          onUpdateField({
            ...selectedField,
            [key]: value,
          });
        }}
      />

      <ConditionsEditor
        field={selectedField}
        schema={schema}
        onSave={handleConditionsSave}
        activeTabId={activeTabId}
      />
    </div>
  );
}
